export enum AccountingLedgerBasis {
    cash = "cash",
    accruals = "accruals",
}

export enum AccountingLedgerStatus {
    active = "active",
    archived = "archived",
}

export enum AccountingLedgerPurpose {
    entityBooks = "entity_books",
    consolidationOverlay = "consolidation_overlay",
}

export const BOTH_LEDGER_BASIS = "cash_and_accrual" as const;
export type LedgerBasisInput = AccountingLedgerBasis | typeof BOTH_LEDGER_BASIS;
